import { render, staticRenderFns } from "./TableCustomer.vue?vue&type=template&id=c077f978&scoped=true"
import script from "./TableCustomer.vue?vue&type=script&lang=js"
export * from "./TableCustomer.vue?vue&type=script&lang=js"
import style0 from "./TableCustomer.vue?vue&type=style&index=0&id=c077f978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c077f978",
  null
  
)

export default component.exports